import {InputLabel, withStyles} from '@material-ui/core';
import {getDirectionStyles} from '../../../../../utils/ThemeUtils';

const HorizontalLabel = withStyles(theme => ({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        margin: getDirectionStyles(theme.direction)(
            theme.spacing(0, 0.5, 0, 0),
            theme.spacing(0, 0, 0, 1.5)
        ),

        '& > div': {
            margin: getDirectionStyles(theme.direction)(
                theme.spacing(0, 0, 0, 1.5),
                theme.spacing(0, 1.5, 0, 0)
            )
        }
    }
}))(InputLabel);

export default HorizontalLabel;
